import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounce } from '../../../utils/debounce';
import { bindFunctionsToThis } from '../../extensions';
import { FieldComponent } from '../field/field.component';

@Component({
    selector: 'ig-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SearchComponent {
    public isLoading: boolean;
    public searchParam = {
        searchText: '',
        searchResult: {},
        searchTimeout: null,
        isShowSearchResult: false,
        isNoResult: false,
        isShowResultCount: false,
        debounceTime: 500
    };
    public searchFormGroup: FormGroup;
    // @Output() onSearch: EventEmitter<any> = new EventEmitter();
    @Input() onSearch: any;
    @Input() onSearchResultSelected: any;
    @Input() placeHolder: string;
    @Input() public disabled = true;
    @ViewChild('field') field: FieldComponent;
    @ViewChild('container') container: ElementRef;
    @ViewChild('result') result: ElementRef;

    constructor(private formBuilder: FormBuilder) {
        bindFunctionsToThis(this);

        this.searchFormGroup = this.formBuilder.group({
            'search': [null],
        });
    }

    public search() {
        if (!this.searchParam.searchText) {
            this.closeSearchResult();
            return;
        }

        this.isLoading = true;
        this.onSearch(this.searchParam.searchText).subscribe(data => {
            this.searchParam.searchResult = data;
            this.searchParam.isNoResult = !data.length;
            this.organizeResult();
            this.isLoading = false;
        });
        // debounce(this.onSearch, this.searchParam.searchText).subscribe(data => {
        //     this.searchParam.searchResult = data;
        //     this.searchParam.isNoResult = !data.length;
        //     this.organizeResult();
        // });
    }

    public onSearchItemClick(result) {
        this.onSearchResultSelected(result);
        this.closeSearchResult();
        this.field.onBlur();
    }

    private organizeResult() {
        this.searchParam.isShowSearchResult = true;
        let wrap = this.container.nativeElement.getBoundingClientRect();
        setTimeout(() => {
            if (this.result) {
                this.result.nativeElement.style.minWidth = `${wrap.width}px`;
            }
        });
        window.addEventListener('click', this.closeSearchResult);
    }

    private closeSearchResult() {
        this.searchParam.isShowSearchResult = false;
    }

    public clearSearchText() {
        this.searchParam.searchText = '';
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/search/search.component.ts